import React, { PropsWithChildren } from "react";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { ListItemIconStyled } from "./NavItem.styles";
import { ListItemText, ListItem } from "@mui/material";

interface NavItemProps {
  to: string;
  icon: React.ReactNode;
  title: string;
}

export default function NavItem({ to, icon, title }: NavItemProps) {
  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps: PropsWithChildren<{}>, ref: any) => <RouterLink to={to} ref={ref} {...itemProps} />),
    [to]
  );
  const routeMatch = useRouteMatch(to);

  return (
    <ListItem button component={renderLink} selected={routeMatch?.isExact}>
      <ListItemIconStyled>{icon}</ListItemIconStyled>
      <ListItemText primary={title} />
    </ListItem>
  );
}
